import type { EmvKernelProfileDto } from "../../types/EmvKernelProfileDto";
import type { EmvKernelProfileEntity } from "../../types/EmvKernelProfileEntity";

export const EmvKernelProfileEntityToDto = ({
    capKeysIptFile,
    capKeysOptFile,
    capKeysUnattendedFile,
    ...rest
}: Readonly<EmvKernelProfileEntity>): EmvKernelProfileDto => {
    const deleteCapKeysIptFile = typeof capKeysIptFile === "boolean";
    const deleteCapKeysOptFile = typeof capKeysOptFile === "boolean";
    const deleteCapKeysUnattendedFile = typeof capKeysUnattendedFile === "boolean";

    return { ...rest, deleteCapKeysIptFile, deleteCapKeysOptFile, deleteCapKeysUnattendedFile };
};
